<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          @click="openAdd"
          color="primary"
          type="filled"
        >
          Add New
        </vs-button>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div v-if="searchable" style="float:right;">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(promo_status)="data">
          <span v-if="data.item.promo_status == 1" class="text-success"
            >Active</span
          >
          <span v-if="data.item.promo_status == 0" class="text-danger"
            >Inactive</span
          >
        </template>

        <template v-slot:cell(promotitle)="data">
          <div>{{ data.item.promotitle }}</div>
          <div style="font-size: 10px; color: rgba(0,0,0,.45);">https://book.{{ domainName }}.com/{{ folder }}?cmp={{ data.item.token }}</div>
        </template>

        <template v-slot:cell(disctype)="data">
          <strong v-if="data.item.disctype == 'percent'"
            >{{ data.item.discvalue | numFormat("0,0") }}%</strong
          >
          <strong v-if="data.item.disctype == 'amount'"
            >{{ data.item.discvalue | numFormat("0,0.00") }} Baht</strong
          >
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >Edit</vs-button
          >
        </template>
      </b-table>
      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          :max="7"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Service from "@/services";

import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data: () => ({
    columns: [
      { label: "ID", key: "promo_id", sortable: false },
      { label: "Status", key: "promo_status", sortable: false },
      {
        label: "Title",
        key: "promotitle",
        sortable: false,
        tdClass: "width-450"
      },
      {
        label: "Description",
        key: "promodesc",
        sortable: false,
        tdClass: "width-450"
      },
      { label: "Discount", key: "disctype", sortable: false },
      { label: "Level", key: "disclevel", sortable: false },
      { label: "Discount from", key: "discfrom", sortable: false },
      { label: "Start", key: "date_start", sortable: false },
      { label: "End", key: "date_end", sortable: false },
      { label: "Applies to", key: "applyto", sortable: false },
      // { label: "Apply to", key: "applyto", sortable: false },
      { label: "Note", key: "promonote", sortable: false },
      { label: "", key: "action", sortable: false }
    ],
    searchable: true,
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    paramsData: "",
    domainName: '',
    folder: ''
  }),
  watch: {
		'currentPage'(val, oldVal) {
			if (oldVal != val) {
				this.getDataPage(val)
			}
		}
	},
  mounted() {
    window.addEventListener("keydown", e => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() {},
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;

        let data = {
          e: this.$route.query.e,
          // promo_type: "link"
          promo_type: this.$route.path === '/promotions' ? 'std': 'link'
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        // params =
        //   params +
        //   "&" +
        //   Object.keys(ctx)
        //     .map(key => key + "=" + ctx[key])
        //     .join("&");

          const path = this.$route.path === '/promotions' ? 'promotions': 'special_links';
          this.paramsData = params + `&type=${path}&page=${this.currentPage}`;
        Service.Bootsale.getPromos(this.paramsData)
          .then(res => {
            this.isBusy = false;
            this.domainName = this.$route.query.s
            this.folder = this.$route.query.e
            this.data = res.rows;
            this.totalRows = res.paginate.total_items;
            this.currentPage = res.paginate.current_page;
            this.perPage = res.paginate.per_page;
            // this.totalRows = res.data.total;
            // this.from = res.data.from;
            // this.to = res.data.to;
            // this.data = res.data.rows;
            // this.log = res.log;
            // this.lagacy_query = res.lagacy_query;

            callback(this.data);
          })
          .catch(error => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push(
        "/saletriggers/" + item.promo_id + "/view?e=" + this.e + "&s=" + this.s
      );
    },
    openAdd() {
      const path = this.$route.path;
      if (path === '/promotions') {
        this.$router.push(`/saletriggers/add-promo?s=${this.s}&e=${this.e}`)
      }
      else {
        this.$router.push(`/saletriggers/add?s=${this.s}&e=${this.e}`)
      }
    },
    getDataPage(page) {
          const path = this.$route.path === '/promotions' ? 'promotions': 'special_links';
          let data = {
          e: this.$route.query.e,
          promo_type: this.$route.path === '/promotions' ? 'std': 'link',
          filter: this.filter
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

          this.paramsData = params + `&filter=${this.filter}&type=${path}&page=${page}`
        Service.Bootsale.getPromos(this.paramsData)
          .then(res => {
            this.isBusy = false;
            // console.log(res, 'data')
            this.data = res.rows;
            this.totalRows = res.paginate.total_items;
            this.currentPage = res.paginate.current_page;
            this.perPage = res.paginate.per_page;

          })
          .catch(() => {
            // console.log(error);
          });
    }
  }
};
</script>
